"use strict";
import React from "react";
import { Modal } from "react-bootstrap";
import Formsy from "./formsy";

var timerInteral;

const initComponent = (flex = window.flex) => {

    class TimeoutPrompt extends React.PureComponent {
        constructor(props) {
            super(props);

            this.state = {
                timeRemaining: props.timeRemaining,
                expiresAt: props.expiresAt,
                serverOffset: moment.duration(moment(props.serverTime).diff(moment())),
                show: true
            };
        }

        componentDidMount() {
            const me = this;
            const props = this.props;
            flex.log(`TIMEOUT PROMPT LAUNCHED: `, props);
            // when component mounts start updating time.
            timerInteral = setInterval(function () { me.updateTime() }, 1000);
        }

        close = () => {
            this.setState({ show: false });
            if (timerInteral) {
                clearInterval(timerInteral);
            }
            // pause for effect
            setTimeout(() => {
                const props = this.props;
                if (props.onClose) {
                    props.onClose();
                }
                flex.timeoutPrompt(false);
                flex.log(`TIMEOUT PROMPT CLOSED: `, props);
            }, 300);
        };

        updateTime = () => {
            const prompt = this;

            var newRemainingTime = moment.duration(this.state.expiresAt.diff(moment()));
            prompt.setState({ timeRemaining: moment.duration(newRemainingTime._milliseconds).subtract(prompt.state.serverOffset) })

            if (prompt.state.timeRemaining < 0) {
                if (timerInteral) {
                    clearInterval(timerInteral);
                }

                if (this.props.onExpire) {
                    this.props.onExpire();
                }
            }
        };

        render() {
            const me = this;
            const state = this.state;
            const show = state.show;
            const props = this.props;

            state.message = state.timeRemaining._milliseconds > 0 ? props.message.replace("{{TIMEOUT}}", moment(state.timeRemaining.asMilliseconds()).format('mm:ss')) : "Logging off..."

            const footer = props.hideFooter ? false :
                <div>
                    <a show={state.timeRemaining._milliseconds > 0} onClick={this.close} className="btn btn-submit">OK</a>
                </div>

            return (
                <Modal show={show} onHide={this.close} className="modalComponent" backdrop="static" data-keyboard="false">
                    <Formsy.Form style={{ textAlign: "left" }}>
                        <Modal.Header>
                            <Modal.Title>{props.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div dangerouslySetInnerHTML={{ __html: state.message || "Your session is about to expire." }}>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {footer}
                        </Modal.Footer>
                    </Formsy.Form>
                </Modal>
            );
        }
    }

    return TimeoutPrompt;
};

module.exports = initComponent;
